import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getWorksMaterialConsumptionRateNorms(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS,dtConfig[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].getWorksMaterialConsumptionRateNorms,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}
function getBaseWorksMaterialConsumptionRateNorms(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS,dtConfig[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].getBaseWorksMaterialConsumptionRateNorms,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}
function getExtendedWorksMaterialConsumptionRateNorms(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS,dtConfig[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].getExtendedWorksMaterialConsumptionRateNorms,
		{
			urlParams: {
				companyId: companyId,
			},
		},
		cashedPayload
	)
}

function createWorksMaterialConsumptionRateNorm(companyId, data) {
	return dataTransferWrap(
		ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS,dtConfig[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].createWorksMaterialConsumptionRateNorm,
		{
			urlParams: {
				companyId,
			},
			...data,
		},
	)
}

function getWorksMaterialConsumptionRateNorm(companyId, worksMaterialConsumptionRateNormId) {
	return dataTransferWrap(
		ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS,dtConfig[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].getWorksMaterialConsumptionRateNorm,
		{
			urlParams: {
				companyId,
				worksMaterialConsumptionRateNormId,
			},
		},
	)
}

function patchWorksMaterialConsumptionRateNorm(companyId, worksMaterialConsumptionRateNormId, data) {
	return dataTransferWrap(
		ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS,dtConfig[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].patchWorksMaterialConsumptionRateNorm,
		{
			urlParams: {
				companyId,
				worksMaterialConsumptionRateNormId,
			},
			...data,
		},
	)
}

function putWorksMaterialConsumptionRateNorm(companyId, worksMaterialConsumptionRateNormId, data) {
	return dataTransferWrap(
		ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS,dtConfig[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].putWorksMaterialConsumptionRateNorm,
		{
			urlParams: {
				companyId,
				worksMaterialConsumptionRateNormId,
			},
			...data,
		},
	)
}

function deleteWorksMaterialConsumptionRateNorm(companyId, worksMaterialConsumptionRateNormId) {
	return dataTransferWrap(
		ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS,dtConfig[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS].deleteWorksMaterialConsumptionRateNorm,
		{
			urlParams: {
				companyId,
				worksMaterialConsumptionRateNormId,
			},
		},
	)
}

export default {
	getWorksMaterialConsumptionRateNorms,
	getBaseWorksMaterialConsumptionRateNorms,
	getExtendedWorksMaterialConsumptionRateNorms,
	getWorksMaterialConsumptionRateNorm,
	patchWorksMaterialConsumptionRateNorm,
	putWorksMaterialConsumptionRateNorm,
	createWorksMaterialConsumptionRateNorm,
	deleteWorksMaterialConsumptionRateNorm,
}